export default __webpack_public_path__ + "static/media/shop1.e7de8c8b.jpg";